import {componentsTheme} from './../mui-core';
import {createTheme, responsiveFontSizes} from '@mui/material/styles';
import {MyriadProFonts} from 'sharedResources/assets/fonts/MyriadPro';

const interFontFamily = 'Inter';
const firaSansFontFamily = 'Fira Sans';

// FiraSans Variants
const Display = {
  lg: {
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '4.667rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '4.667rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '4.667rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '4.667rem',
      fontFamily: firaSansFontFamily,
    },
  },
  md: {
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '3.8rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '3.8rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '3.8rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '3.8rem',
      fontFamily: firaSansFontFamily,
    },
  },
  sm: {
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '3.2rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '3.2rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '3.2rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '3.2rem',
      fontFamily: firaSansFontFamily,
    },
  },
};
const Header = {
  lg: {
    // variant = h1
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '2.8rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '2.8rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '2.8rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '2.8rem',
      fontFamily: firaSansFontFamily,
    },
  },
  md: {
    // variant = h2
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '2.667rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '2.667rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '2.667rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '2.667rem',
      fontFamily: firaSansFontFamily,
    },
  },
  sm: {
    // variant = h3
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '2.2rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '2.2rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '2.2rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '2.2rem',
      fontFamily: firaSansFontFamily,
    },
  },
};
const Title = {
  lg: {
    // variant = h4
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '1.867rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '1.867rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '1.867rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '1.867rem',
      fontFamily: firaSansFontFamily,
    },
  },
  md: {
    // variant = h5
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '1.533rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '1.533rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '1.533rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '1.533rem',
      fontFamily: firaSansFontFamily,
    },
  },
  sm: {
    // variant = h6
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '1.267rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '1.267rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '1.267rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '1.267rem',
      fontFamily: firaSansFontFamily,
    },
  },
  xs: {
    thin: {
      fontWeight: 300,
      lineHeight: 1.25,
      fontSize: '1.067rem',
      fontFamily: firaSansFontFamily,
    },
    medium: {
      fontWeight: 500,
      lineHeight: 1.25,
      fontSize: '1.067rem',
      fontFamily: firaSansFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.25,
      fontSize: '1.067rem',
      fontFamily: firaSansFontFamily,
    },
    black: {
      fontWeight: 900,
      lineHeight: 1.25,
      fontSize: '1.067rem',
      fontFamily: firaSansFontFamily,
    },
  },
};
const Caption = {
  light: {
    fontWeight: 300,
    lineHeight: 1.5,
    fontSize: '2.0625rem',
    fontFamily: firaSansFontFamily,
  },
  medium: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '2.0625rem',
    fontFamily: firaSansFontFamily,
  },
};
const Quote = {
  light: {
    fontWeight: 300,
    lineHeight: 1.5,
    fontStyle: 'italic',
    fontSize: '2.0625rem',
    fontFamily: firaSansFontFamily,
  },
  medium: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontStyle: 'italic',
    fontSize: '2.0625rem',
    fontFamily: firaSansFontFamily,
  },
};

// Inter Variants
const Text = {
  xl: {
    regular: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontSize: '1.333rem',
      fontFamily: interFontFamily,
    },
    italic: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontStyle: 'italic',
      fontSize: '1.333rem',
      fontFamily: interFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: '1.333rem',
      fontFamily: interFontFamily,
    },
  },
  lg: {
    regular: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontSize: '1.133rem',
      fontFamily: interFontFamily,
    },
    italic: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontStyle: 'italic',
      fontSize: '1.133rem',
      fontFamily: interFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: '1.133rem',
      fontFamily: interFontFamily,
    },
  },
  md: {
    regular: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
      fontFamily: interFontFamily,
    },
    italic: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
      fontStyle: 'italic',
      fontFamily: interFontFamily,
    },
    bold: {
      fontWeight: 700,
      fontSize: '1rem',
      lineHeight: 1.5,
      fontFamily: interFontFamily,
    },
  },
  sm: {
    regular: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontSize: '0.867rem',
      fontFamily: interFontFamily,
    },
    italic: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontStyle: 'italic',
      fontSize: '0.867rem',
      fontFamily: interFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: '0.867rem',
      fontFamily: interFontFamily,
    },
  },
  xs: {
    regular: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontSize: '0.733rem',
      fontFamily: interFontFamily,
    },
    italic: {
      fontWeight: 400,
      lineHeight: 1.5,
      fontStyle: 'italic',
      fontSize: '0.733rem',
      fontFamily: interFontFamily,
    },
    bold: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: '0.733rem',
      fontFamily: interFontFamily,
    },
  },
};
const Label = {
  lg: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: '1.067rem',
    fontFamily: interFontFamily,
  },
  md: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.867rem',
    fontFamily: interFontFamily,
  },
  sm: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.733rem',
    fontFamily: interFontFamily,
  },
  xs: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.6rem',
    fontFamily: interFontFamily,
  },
};

const getAppTheme = () => {
  const theme = createTheme({
    cssVariables: {
      colorSchemeSelector: 'class',
    },
    colorSchemes: {
      dark: true,
      light: true,
    },
    palette: {
      background: {
        main: '#F1F1F4',
        dark: '#000000',
        white: '#fff',
      },
      primary: {
        main: '#635BFF',
        dark: '#4E36F5',
      },
      secondary: {
        main: '#1DB0F8',
        light: '#1DB0F8',
      },
      success: {
        main: '#98BF0E',
        light: '#81c784',
        dark: '#388e3c',
        contrastText: '#fff',
      },
      error: {
        main: '#b71c1c', // '#DB3024',
        light: '#d32f2f',
        dark: '#b71c1c',
        contrastText: '#fff',
      },
      grey: {
        main: '#667085',
        contrastText: '#fff',
      },
      darkGray: {
        main: '#333333',
        contrastText: '#fff',
      },
      midGray: {
        main: '#a0a4b5',
        contrastText: '#fff',
      },
      grayLight: {
        main: '#F5F5F5',
        light: '#F1F1F4',
      },
      grayBorder: {
        main: '#D8D8D8',
      },
      dialogDarkBG: {
        main: '#181818',
        contrastText: '#000',
      },
      lightViolet: {
        light: '#E5E6FF',
        main: '#7b60df4d',
        contrastText: '#fff',
      },
      purpleBG: {
        main: '#f3f2fc',
      },
      taleBlue: {
        main: '#06AED4',
        contrastText: '#000',
      },
      tale200: {
        main: '#99F6E0',
        contrastText: '#000',
      },
      tale400: {
        main: '#2ED3B7',
        contrastText: '#000',
      },
      grey400: {
        main: '#98A2B3',
        contrastText: '#fff',
      },
      grey800: {
        main: '#424242',
        contrastText: '#fff',
      },
      greyLight800: {
        main: '#182230',
        contrastText: '#fff',
      },
      backgroundL1: {
        main: '#F9FAFB',
        contrastText: '#000',
      },
      text: {
        primary: '#212636',
        contrastText: '#fff',
      },
      brand200: {
        primary: '#D9D6FE',
        contrastText: '#fff',
      },
      brand500: {
        primary: '#7A5AF8',
        contrastText: '#fff',
      },
      shadeyBlack: {
        main: '#212636',
        contrastText: '#fff',
      },
      emailChip: {
        main: '#D1E9FF',
      },
      newlyAddedChip: {
        main: '#CCFBEF',
      },
      recentlyActiveChip: {
        main: '#FBDBDE',
      },
    },
    components: {
      ...componentsTheme.components,
      MuiButton: {
        styleOverrides: {
          root: ({ownerState}) => ({
            borderRadius: '8px',
            fontFamily: 'Inter',
            width: ownerState.width,
            textTransform: 'capitalize',
            variants: [
              {
                props: {
                  color: 'primary',
                },
                style: {
                  color: '#635BFF',
                },
              },
              {
                props: {
                  disabled: false,
                  color: 'primary',
                  variant: 'contained',
                },
                style: {
                  color: '#fff',
                  border: '1px solid #4E36F5',
                  boxShadow: '0px 1px 2px 0px #00000014',
                  background: 'linear-gradient(#635BFF, #4E36F5)',
                },
              },
              {
                props: {
                  color: 'primary',
                  variant: 'outlined',
                },
                style: {
                  color: '#635BFF',
                  border: '1px solid #635BFF80',
                  boxShadow: '0px 1px 2px 0px #00000014',
                },
              },
              {
                props: {
                  size: 'medium',
                },
                style: {
                  fontSize: '14px',
                  minHeight: '40px',
                  padding: '4px 12px',
                  lineHeight: '24px',
                },
              },
              {
                props: {
                  size: 'small',
                },
                style: {
                  fontSize: '12px',
                },
              },
              {
                props: {
                  size: 'large',
                },
                style: {
                  fontSize: '16px',
                },
              },
            ],
          }),
        },
      },
      MuiCssBaseline: {
        styleOverrides: `
        /* Scrollbar styles */
        &::-webkit-scrollbar {
          width: 4px !important;
          height: 4px !important;
          background-color: rgba(123, 96, 223, 0.3);
        }
        &::-webkit-scrollbar-thumb {
          background-color: #0367FF !important;
          border-radius: 14px;
        }
    `,
      },
    },
    typography: {
      fontSize: 15, // default is 14; this changes 1rem to 15px
      fontFamily: [interFontFamily, firaSansFontFamily],
      h1: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '40px',
      },
      h2: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '27px',
      },
      h3: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '23px',
      },
      h4: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '20px',
      },
      h5: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '18px',
      },
      h6: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '16px',
      },
      // custom typography
      h7: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '14px',
      },
      body1: {
        fontSize: '14px',
      },
      body2: {
        fontSize: '12px',
      },
      bodyL: {
        fontSize: '16px',
      },
      bodyXL: {
        fontSize: '18px',
      },
      subtitle1: {
        fontFamily: 'MyriadProSemiBold',
        fontSize: '16px',
      },
      subtitle2: {
        fontSize: '15px',
      },
      caption: {
        fontSize: '13px',
      },
      metricNo: {
        fontSize: '40px',
        fontWeight: 300,
        fontFamily: firaSansFontFamily,
      },
      pageTitle: {
        fontSize: '50px',
        fontFamily: 'MyriadProBold',
      },
      pageDesc: {
        fontSize: '17px',
      },
      popupCaptions: {
        fontSize: '30px',
        fontFamily: 'MyriadProSemiBold',
      },
    },
    breakpoints: {
      values: {
        xs: 360,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1440,
      },
    },
  });
  // Design System Typography Variants
  // Display
  theme.typography['display-lg-thin'] = {
    ...Display.lg.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '4.266rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.2rem',
    },
  };
  theme.typography['display-lg-medium'] = {
    ...Display.lg.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '4.266rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.2rem',
    },
  };
  theme.typography['display-lg-bold'] = {
    ...Display.lg.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '4.266rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.2rem',
    },
  };
  theme.typography['display-lg-black'] = {
    ...Display.lg.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '4.266rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.2rem',
    },
  };
  theme.typography['display-md-thin'] = {
    ...Display.md.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3.6rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  };
  theme.typography['display-md-medium'] = {
    ...Display.md.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3.6rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  };
  theme.typography['display-md-bold'] = {
    ...Display.md.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3.6rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  };
  theme.typography['display-md-black'] = {
    ...Display.md.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3.6rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '3.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  };
  theme.typography['display-sm-thin'] = {
    ...Display.sm.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.667rem',
    },
  };
  theme.typography['display-sm-medium'] = {
    ...Display.sm.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.667rem',
    },
  };
  theme.typography['display-sm-bold'] = {
    ...Display.sm.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.667rem',
    },
  };
  theme.typography['display-sm-black'] = {
    ...Display.sm.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.667rem',
    },
  };

  // Header
  theme.typography['header-lg-thin'] = {
    ...Header.lg.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.667rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['header-lg-medium'] = {
    ...Header.lg.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.667rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['header-lg-bold'] = {
    ...Header.lg.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.667rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['header-lg-black'] = {
    ...Header.lg.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.667rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['header-md-thin'] = {
    ...Header.md.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.533rem',
    },
  };
  theme.typography['header-md-medium'] = {
    ...Header.md.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.533rem',
    },
  };
  theme.typography['header-md-bold'] = {
    ...Header.md.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.533rem',
    },
  };
  theme.typography['header-md-black'] = {
    ...Header.md.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.533rem',
    },
  };
  theme.typography['header-sm-thin'] = {
    ...Header.sm.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.267rem',
    },
  };
  theme.typography['header-sm-medium'] = {
    ...Header.sm.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.267rem',
    },
  };
  theme.typography['header-sm-bold'] = {
    ...Header.sm.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.267rem',
    },
  };
  theme.typography['header-sm-black'] = {
    ...Header.sm.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.867rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.267rem',
    },
  };

  // Title
  theme.typography['title-lg-thin'] = {
    ...Title.lg.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.133rem',
    },
  };
  theme.typography['title-lg-medium'] = {
    ...Title.lg.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.133rem',
    },
  };
  theme.typography['title-lg-bold'] = {
    ...Title.lg.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.133rem',
    },
  };
  theme.typography['title-lg-black'] = {
    ...Title.lg.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.533rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.133rem',
    },
  };
  theme.typography['title-md-thin'] = {
    ...Title.md.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['title-md-medium'] = {
    ...Title.md.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['title-md-bold'] = {
    ...Title.md.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['title-md-black'] = {
    ...Title.md.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['title-sm-thin'] = {
    ...Title.sm.thin,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-sm-medium'] = {
    ...Title.sm.medium,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-sm-bold'] = {
    ...Title.sm.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-sm-black'] = {
    ...Title.sm.black,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-xs-thin'] = {
    ...Title.xs.thin,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-xs-bold'] = {
    ...Title.xs.bold,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-xs-black'] = {
    ...Title.xs.black,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['title-xs-medium'] = {
    ...Title.xs.medium,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };

  // Text
  theme.typography['text-xl-regular'] = {
    ...Text.xl.regular,
    [theme.breakpoints.down('xl')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['text-xl-italic'] = {
    ...Text.xl.italic,
    [theme.breakpoints.down('xl')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['text-xl-bold'] = {
    ...Text.xl.bold,
    [theme.breakpoints.down('xl')]: {
      fontSize: '1.267rem',
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.133rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.067rem',
    },
  };
  theme.typography['text-lg-regular'] = {
    ...Text.lg.regular,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  };
  theme.typography['text-lg-italic'] = {
    ...Text.lg.italic,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  };
  theme.typography['text-lg-bold'] = {
    ...Text.lg.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.067rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  };
  theme.typography['text-md-regular'] = {
    ...Text.md.regular,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['text-md-italic'] = {
    ...Text.md.italic,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['text-md-bold'] = {
    ...Text.md.bold,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['text-sm-regular'] = {
    ...Text.sm.regular,
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.733rem',
    },
  };
  theme.typography['text-sm-italic'] = {
    ...Text.sm.italic,
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.733rem',
    },
  };
  theme.typography['text-sm-bold'] = {
    ...Text.sm.bold,
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.733rem',
    },
  };
  theme.typography['text-xs-bold'] = {
    ...Text.xs.bold,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.6rem',
    },
  };
  theme.typography['text-xs-italic'] = {
    ...Text.xs.italic,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.6rem',
    },
  };
  theme.typography['text-xs-regular'] = {
    ...Text.xs.regular,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.6rem',
    },
  };

  // Label
  theme.typography['label-lg'] = {
    ...Label.lg,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.867rem',
    },
  };
  theme.typography['label-md'] = {
    ...Label.md,
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.733rem',
    },
  };
  theme.typography['label-sm'] = {
    ...Label.sm,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.6rem',
    },
  };
  theme.typography['label-xs'] = {...Label.xs};

  // Quote
  theme.typography['quote-light'] = {
    ...Quote.light,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['quote-medium'] = {
    ...Quote.medium,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
  };

  // Caption
  theme.typography['caption-light'] = {
    ...Caption.light,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
  };
  theme.typography['caption-medium'] = {
    ...Caption.medium,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.867rem',
    },
  };

  // custom Typography Components
  const defaultFontProps = {
    fontFamily: interFontFamily,
  };
  theme.typography['body1'] = {
    ...defaultFontProps,
    fontSize: 14,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  };
  theme.typography['body2'] = {
    ...defaultFontProps,
    fontSize: 12,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
  };
  return responsiveFontSizes(theme);
};

export {getAppTheme};
